'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _components = require('components');

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _utils = require('utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GridPack = function (_React$Component) {
  (0, _inherits3.default)(GridPack, _React$Component);

  function GridPack() {
    (0, _classCallCheck3.default)(this, GridPack);
    return (0, _possibleConstructorReturn3.default)(this, (GridPack.__proto__ || (0, _getPrototypeOf2.default)(GridPack)).apply(this, arguments));
  }

  (0, _createClass3.default)(GridPack, [{
    key: 'render',
    value: function render() {
      var pack = this.props.pack;
      var id = pack.id,
          name = pack.name,
          priceMap = pack.priceMap,
          isIncomplete = pack.isIncomplete,
          presentation = pack.presentation;


      var isOnSale = priceMap.length > 0 && !!priceMap[0].comparePrice && !!priceMap[0].discount;

      var styles = require('./GridPack.scss');

      var classes = (0, _classnames3.default)((0, _defineProperty3.default)({}, styles.GridPack, true));

      var src = presentation && presentation.coverImages && (0, _utils.getS3Url)(presentation.coverImages[0]);

      var linkTo = isIncomplete ? '/megascans/library/packs/' + id : '/packs/' + id;

      return _react2.default.createElement(
        'li',
        { className: classes, style: { backgroundImage: 'url(' + src + ')' } },
        _react2.default.createElement(
          _reactRouter.Link,
          { to: linkTo, className: styles.GridPack__wrap },
          _react2.default.createElement(
            'div',
            { className: styles.GridPack__guts },
            isIncomplete && _react2.default.createElement(
              'span',
              { className: styles.GridPack__comingSoon },
              'Coming Soon'
            ),
            _react2.default.createElement(
              'h1',
              { className: styles.GridPack__title },
              name
            ),
            _react2.default.createElement(
              'h2',
              { className: styles.GridPack__description },
              presentation && presentation.subtitle
            )
          ),
          isOnSale && _react2.default.createElement(
            'div',
            { className: styles.SaleRibbon },
            priceMap[0].discount + ' OFF'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.GridPack__actions },
          _react2.default.createElement(_components.Button, { link: true, to: '/megascans/library/packs/' + id, label: 'View Pack Assets', className: styles.GridPack__action }),
          !isIncomplete && _react2.default.createElement(_components.Button, { primary: true, link: true, to: '/packs/' + id, label: 'Learn More', className: styles.GridPack__action })
        )
      );
    }
  }]);
  return GridPack;
}(_react2.default.Component);

exports.default = GridPack;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/GridPack/GridPack.jsx
// module id = 2595
// module chunks = 0